export default class ErrorParser {
  constructor(error, rootStore) {
    this.error = error;

    let message = error.message;

    if (error.response && error.response.data && error.response.data.Message) {
      this.message = error.response.data.Message;
      this.exceptionMessageDetail = this.exceptionMessage =
        error.response.data.ExceptionMessage;

      this.exceptionType = error.response.data.ExceptionType;
      if (error.response.data.StackTrace) {
        this.stackTraceLines = error.response.data.StackTrace.split("\n");
      }

      if (this.exceptionType === "System.Data.SqlClient.SqlException") {
        if (/DELETE.+REFERENCE.+"FK_.+"/.test(this.exceptionMessage)) {
          message = rootStore.ui.translate.FkDeleteMessage;
          this.exceptionMessage = "";
        }
      }
      this.hasDetail = true;
    } else if (
      error.response &&
      error.response.status === 400 &&
      error.response.data &&
      error.response.data.error
    ) {
      const translatedErrorMessage =
        rootStore.ui.translate[error.response.data.error_description];
      if (translatedErrorMessage) message = translatedErrorMessage;
      else
        message = `${error.response.data.error}: ${
          error.response.data.error_description
        }`;
    } else if (
      error.response &&
      (error.response.status === 400 || error.response.status === 405)
    ) {
      const translatedErrorMessage =
        rootStore.ui.translate[error.response.statusText];
      if (translatedErrorMessage) message = translatedErrorMessage;
      else message = `${message}: ${error.response.statusText}`;
    } else if (
      error.response &&
      (typeof error.response.data === "string" ||
        error.response.data instanceof String)
    ) {
      this.exceptionMessage = error.response.data;
    }

    this.message = message;
  }

  get isConcurrenyError() {
    const error = this.error;
    const concurrenyError =
      error &&
      error.response &&
      error.response.data &&
      error.response.data.ExceptionMessage &&
      error.response.data.ExceptionMessage.includes("xx_concurrency error");
    return concurrenyError;
  }
}



// WEBPACK FOOTER //
// ./src/Core/ErrorParser.js